import { Link } from "react-router-dom";
import styled from "styled-components";

const ItemContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 6px;
  transition: all 0.15s linear;
  color: #1a1a1a;
  text-decoration: none;
  font-size: 15px;
  font-weight: 300;

  &:hover {
    color: black;
    background-color: hsla(0, 0%, 0%, 0.1);
    text-decoration: none;
  }

  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    fill: currentColor;
    transform: rotate(-90deg);
  }

  @media screen and (max-width: 767px) {
    padding: 8px;
  }
`

export default ItemContainer